import { asArray, isDateLess } from './promoPrimitives';
import { isCampaignInNegoPeriod } from './promoPhase';

// Photos of the promo step (#23521). The upload, the file naming and the offline cache stay legacy (`addPhoto`,
// `removePhoto`, photoUpload.js) ; the snapshot lists the photos the way `currentPromoPhotos` keys them : the campaign id
// for a national campaign, `campaignId_offerKey` for a local offer. RG-20 : no photo during the negotiation, except on a
// local offer. Port of the visibility rules of the template (HTM:294-325, 404-473) and `isPhotoStatementActive` (JS:1452).

export const MAX_PHOTOS = 2;

const photoKey = (campaignId, offerKey) => (offerKey ? `${campaignId}_${offerKey}` : campaignId);

/** `getPhotosPromo` (JS:4513) : statement photos carry `isStatement`, the others do not. */
export function photosOf(snapshot, campaignId, offerKey = null, isStatement = false) {
	return asArray(snapshot?.photos?.[photoKey(campaignId, offerKey)]).filter((p) => (isStatement ? p.isStatement === true : p.isStatement === undefined || p.isStatement === null));
}

/** Statement photos of a national campaign : once out of the nego period, on campaigns with photos ; added during the store period. */
export function nationalPhotoRules(snapshot, campaign) {
	const items = photosOf(snapshot, campaign.id);
	const visible = (!isCampaignInNegoPeriod(campaign) && !!campaign.photoStatementActive) || (!!snapshot?.readonly && items.length > 0);
	return { visible, items, canAdd: visible && items.length < MAX_PHOTOS && !snapshot?.readonly && !!campaign.inStorePeriod, canEdit: !snapshot?.readonly };
}

/**
 * Photos of a local offer : nego photos before its store period, statement photos during it. `negoDisplay` : the offer
 * stays in the negotiation display during its store period while its forecast is on (RG-24), with its nego photos. Once
 * the offer has started (or in a read-only visit), the nego block only shows the photos taken : with none, it disappears instead of leaving its
 * label alone.
 */
export function localPhotoRules(snapshot, campaign, offerInfo, negoDisplay = false) {
	const started = isDateLess(offerInfo?.startDate, snapshot?.now, true) && !negoDisplay;
	const readonly = !!snapshot?.readonly;
	const nego = photosOf(snapshot, campaign.id, offerInfo._key);
	const statement = photosOf(snapshot, campaign.id, offerInfo._key, true);
	return {
		nego: { visible: (!started && !readonly) || nego.length > 0, items: nego, canAdd: nego.length < MAX_PHOTOS && !readonly && !started, canEdit: !readonly && !started },
		statement: { visible: (started && !!campaign.photoStatementActive) || (readonly && statement.length > 0), items: statement, canAdd: statement.length < MAX_PHOTOS && !readonly && started, canEdit: !readonly && started },
	};
}
